<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content container-fluid" style="color: var(--theme-text-main);">
                        <div class="row">
                             <div class="col-md-6">
                                <h3 class="fw-bold mb-3">Create GiftCard</h3>
                                
                                <div class="mb-3">
                                    <label class="form-label h5">Points To Convert</label>
                                    <input type="text" class="form-control form-control-lg" 
                                        v-model="selfPointsAmount" 
                                        @focus="activeField = 'points'"
                                        placeholder="Enter points"
                                        ref="pointsInput"
                                        readonly
                                        @click="activeField = 'points'"
                                        :class="{'border-primary': activeField === 'points'}"
                                        style="border-width: 2px;background-color: var(--theme-bg-end);"
                                        />
                                </div>

                                <div class="mb-3">
                                    <label class="form-label h5">GiftCard Number</label>
                                    <input type="text" class="form-control form-control-lg" 
                                        v-model="selfGiftCardNumber" 
                                        @focus="activeField = 'card'"
                                        placeholder="Enter card number"
                                        ref="cardInput"
                                        readonly
                                        @click="activeField = 'card'"
                                        :class="{'border-primary': activeField === 'card'}"
                                        style="border-width: 2px;background-color: var(--theme-bg-end);"
                                        />
                                </div>

                                <div class="d-flex justify-content-between mt-4">
                                    <button class="btn btn-success btn-lg flex-grow-1 me-2" style="margin: 4px;" @click="passPointsAmount()">Save</button>
                                    <button class="btn btn-danger btn-lg flex-grow-1" @click="closePopUp">Close</button>
                                </div>
                             </div>

                             <div class="col-md-6 d-flex justify-content-center align-items-center bg-dark rounded p-3">
                                <numericpad  :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true"  backgroundColor="var(--form-color)"textColor="#ffffff" />
                             </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>   
    </transition>
</template>
<script>
import { ref, onMounted } from 'vue'
import axios from "axios";
import commonServices from "@/shared/commonServices"
import numericpad from "@/components/SimpleKeyboard";

export default {
    mixins: [commonServices],

    components: {
        numericpad
    },
    name: "PointsToGiftCard",
    data: function () {
        return {
            selfPointsAmount: '',
            selfGiftCardNumber: '',
            activeField: 'points' // 'points' or 'card'
        }
    },

    methods: {
        onInput(key) {
            if (this.activeField === 'points') {
                 if (key == 11) {
                    this.selfPointsAmount = (this.selfPointsAmount + '0')
                } else {
                    this.selfPointsAmount = (this.selfPointsAmount + key)
                }
            } else if (this.activeField === 'card') {
                 if (key == 11) {
                    this.selfGiftCardNumber = (this.selfGiftCardNumber + '0')
                } else {
                    this.selfGiftCardNumber = (this.selfGiftCardNumber + key)
                }
            }
        },
        onDelete() {
            if (this.activeField === 'points') {
                this.selfPointsAmount = this.selfPointsAmount.slice(0, this.selfPointsAmount.length - 1);
            } else if (this.activeField === 'card') {
                this.selfGiftCardNumber = this.selfGiftCardNumber.slice(0, this.selfGiftCardNumber.length - 1);
            }
        },
        closePopUp(){
            this.selfPointsAmount = '';
            this.selfGiftCardNumber = '';
            this.close();
        },
        onReset() {
             if (this.activeField === 'points') {
                this.selfPointsAmount = "";
            } else if (this.activeField === 'card') {
                this.selfGiftCardNumber = "";
            }
        },
        focusAmount() {
            // this.$refs.pointsAmount.focus(); 
            // Removed direct focus as we use virtual keyboard logic
        },
        async passPointsAmount() {
            try{
                if(parseFloat(this.pointsAmount) < parseFloat(this.selfPointsAmount)){
                    this.showAlert("Points Limit Exceeded");
                }else{
                    let dataURL = this.apiURL+'GiftCards/convertPoints';
                    let loialityJson = {"appId":localStorage.appId, 'customerId': this.customerId, 'cardNumber': this.selfGiftCardNumber, 'amount': this.selfPointsAmount};
                    let response = await axios.post(dataURL, loialityJson); 
                    if(response.data.status == 'error'){
                        if(response.data.msg){
                            this.showAlert(response.data.msg);
                        }else{
                            this.showAlert('Error Occured Please Check You Data');
                        }
                    }else{
                        this.selfGiftCardNumber = "";
                        this.selfPointsAmount = "";
                        this.$emit('getSuccess', true);
                    }
                }
            }catch(err){
                console.log(err);
                this.showAlert('Error Occured Please Try Again');
            }
            this.close();
        },
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        pointsAmount: {
            type: String, // Or Number, better to be consistent
            required: true
        },
        customerId: {
            type: Number,
            required: true
        },
    },
    setup(_, { emit }) {
        const close = () => {
            emit('close');
        };
        return { close };
    },
};
</script>
<style scoped>
*,
::before::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9999; /* Higher z-index to be safe */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    width: 800px; /* Wider for side-by-side layout */
    max-width: 95%;
    /* max-height: 90vh; */
    margin: 0;
}

.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    /* border: 5px solid rgba(0, 0, 0, 0.3); */
    /* background-clip: padding-box; */
    border-radius: 1rem;
    padding: 2rem;
    width: 100%;
    /* height: 100%; */
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(-50px);
}
</style>
